import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Microscope icon
 *
 * @category Product
 */
const Microscope = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          d="M5 15.0003H11.6667M2.5 18.3337H17.5M11.6667 18.3337C13.2138 18.3337 14.6975 17.7191 15.7915 16.6251C16.8854 15.5312 17.5 14.0474 17.5 12.5003C17.5 10.9532 16.8854 9.4695 15.7915 8.37554C14.6975 7.28157 13.2138 6.66699 11.6667 6.66699H10.8333M7.5 11.667H9.16667M10 5.00033V2.50033C10 2.27931 9.9122 2.06735 9.75592 1.91107C9.59964 1.75479 9.38768 1.66699 9.16667 1.66699H7.5C7.27899 1.66699 7.06702 1.75479 6.91074 1.91107C6.75446 2.06735 6.66667 2.27931 6.66667 2.50033V5.00033M7.5 10.0003C7.05797 10.0003 6.63405 9.82473 6.32149 9.51217C6.00893 9.19961 5.83333 8.77569 5.83333 8.33366V5.00033H10.8333V8.33366C10.8333 8.77569 10.6577 9.19961 10.3452 9.51217C10.0326 9.82473 9.60869 10.0003 9.16667 10.0003H7.5Z"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

Microscope.displayName = 'Microscope';

export { Microscope };
